import { render, staticRenderFns } from "./BlockTable.vue?vue&type=template&id=493e5b78&scoped=true&"
import script from "./BlockTable.vue?vue&type=script&lang=js&"
export * from "./BlockTable.vue?vue&type=script&lang=js&"
import style0 from "./BlockTable.vue?vue&type=style&index=0&id=493e5b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e5b78",
  null
  
)

export default component.exports